/**
 * @generated SignedSource<<e6b0ad2bf256aaf072e5b28499cd1bf3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedNewSellerPill_viewer$data = {
  readonly suppressNewSellerSignals: boolean | null;
  readonly " $fragmentType": "PdpSharedNewSellerPill_viewer";
};
export type PdpSharedNewSellerPill_viewer$key = {
  readonly " $data"?: PdpSharedNewSellerPill_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedNewSellerPill_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedNewSellerPill_viewer",
  "selections": [
    {
      "alias": "suppressNewSellerSignals",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "suppressNewSellerSignals"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c2bd0fb30087d5d34ba7bb72b16cc6bc";

export default node;
